import AttendStateFunc from "@/pcomponents/common/content/edu/attend/func/state_func";
import DeskUseDataFunc from "@/pcomponents/common/content/edu/desk/func/desku_func";
import TopInfoArea from "./top_info";
import MidTodoArea from "./mid_todo";
import CardBoxAttendArea from "./attend";
import strFunc from '@/lib/lyg/string';
import plan_complete_stamp_ico from "@/img/ico/todo/plan_complete_stamp_ico.png";
import TodoDailyCArea from "./todo_dailyc";
import TodoDailycStarArea from "./todo_dailyc_star";
import DateFunc from '@/lib/lyg/date_func';
import DailyReportDataFunc from "@/pcomponents/common/content/edu/daily_report/func/data_func";

function CardBox(props: any) {
  let myProps = {
    info: {},
    set_info: (inData: any) => { },
    lecture_info: {},
    subject_name: "",
    Style: {},
    check_row_val_arr: [],
    set_check_row_val_arr: (inData: any) => { },
    openTodoDaySort: (inData: any) => { },
    base_date_str: "",
    pre_date_str: "",
    now_ymdhis: "",
    xColumnArr: {},
    deleteAttend: (inData: any) => { },
    openAttendPopup: (inData: any) => { },
    openTodoWriteOnePopup: (inData: any) => { },
    show_detail_user_by_seq: (inData: any) => { },
    openTodoDailyCWritePopup: (inData: any) => { },
    go_todo_dailyc_write: (inData: any) => { },
    ...props
  };
  let Style = myProps.Style;
  let info = myProps.info;
  let lecture_info = myProps.lecture_info;
  let base_date_str = myProps.base_date_str;
  let pre_date_str = myProps.pre_date_str;
  let subject_name = myProps.subject_name;
  let row_check_val = info["a_seq"] + "," + subject_name;
  let todo_dailyc_info = null;

  let last_daily_info = DailyReportDataFunc.get_last_daily_info_by_lecture({
    stu_info: info,
    lecture_info: lecture_info,
    last_daily_report_arr: info.last_daily_report_arr,
  });
  let daily_info = DailyReportDataFunc.get_daily_info_of_date({
    date_str: base_date_str,
    pre_date_str: pre_date_str,
    last_daily_info: last_daily_info,
    info: info,
    lecture_info: lecture_info,
  });

  let attend_data = AttendStateFunc.get_attend_data_by_user_info({
    user_info: info,
    select_date: base_date_str,
  });

  if (!strFunc.is_empty(subject_name)) {
    if (info.todo_dailyc_arr) {
      for (let i = 0; i < info.todo_dailyc_arr.length; i++) {
        if (info.todo_dailyc_arr[i].a_subject == subject_name) {
          todo_dailyc_info = info.todo_dailyc_arr[i];
          break;
        }
      }
    }
  }

  const on_change_check_box = (e: any) => {
    if (strFunc.is_empty(info["a_seq"])) {
      return false;
    }
    if (e.target.checked) {
      //추가
      let tmp_check_row_val_arr = [...myProps.check_row_val_arr];
      if (strFunc.str_in_array(row_check_val, myProps.check_row_val_arr) == -1) {
        tmp_check_row_val_arr.push(row_check_val);
        myProps.set_check_row_val_arr(tmp_check_row_val_arr);
      }
    } else {
      //제거
      let tmp_check_row_val_arr = [];
      for (let i = 0; i < myProps.check_row_val_arr.length; i++) {
        if (myProps.check_row_val_arr[i] == row_check_val) {

        } else {
          tmp_check_row_val_arr.push(myProps.check_row_val_arr[i]);
        }
      }
      myProps.set_check_row_val_arr(tmp_check_row_val_arr);
    }
    return false;
  };

  let td_sort_data_json = info.td_sort_data_json;
  let td_sort_data_arr: any = [];
  for (let key in td_sort_data_json) {
    if (key != "homework") {
      td_sort_data_arr.push(td_sort_data_json[key]);
    }
  }

  let is_checked = false;
  if (strFunc.str_in_array(row_check_val, myProps.check_row_val_arr) != -1) {
    is_checked = true;
  }
  let is_complete = false;
  let back_white_style: any = {};
  let box_con_style: any = {};
  let box_con_div_style: any = {};
  if (todo_dailyc_info != null) {
    is_complete = true;
    box_con_div_style = {
      background: "#d5d5d5",
      borderRadius: "10px",
      borderBottomRightRadius: "0px",
      borderBottomLeftRadius: "0px",
    };
  }
  if (attend_data.in != null && attend_data.in["a_sort_detail"] == "absent") {
    back_white_style = {
      background: "#d5d5d5",
      position: "relative",
      borderRadius: "10px",
    };
  }

  let desku_info = null;
  if (info.now_desku_arr && info.now_desku_arr.length > 0) {
    for (let i = 0; i < info.now_desku_arr.length; i++) {
      if (info.now_desku_arr[i]["a_subject"] == subject_name) {
        if (desku_info == null) {
          desku_info = info.now_desku_arr[i];
          break;
        }
      }
    }
  }
  if (desku_info == null && info.desk_use_arr && info.desk_use_arr.length > 0) {
    for (let i = 0; i < info.desk_use_arr.length; i++) {
      if (info.desk_use_arr[i]["a_subject"] == subject_name) {
        if (desku_info == null) {
          desku_info = info.desk_use_arr[i];
          break;
        }
      }
    }
  }

  let desk_num_str = "";
  if (desku_info != null) {
    desk_num_str = desku_info["a_name"];
  }

  let desk_use_time_data = DeskUseDataFunc.get_desk_use_time_data({
    now_ymdhis: myProps.now_ymdhis,
    desku_info: desku_info,
  });

  let user_name = "";//홍길동
  let remain_minute_num = desk_use_time_data.remain_minute_num;
  let elapse_minute_num = desk_use_time_data.elapse_minute_num;
  let time_period = desk_use_time_data.time_period;//21:00 ~ 22:30
  let percent_num = desk_use_time_data.percent_num;
  let is_target_time = desk_use_time_data.is_target_time;
  let desk_is_finish = desk_use_time_data.is_finish;

  let desk_back_class_name = Style.desk_back_per;
  if (desku_info != null) {

    user_name = desku_info["a_user_name"];
    if (is_target_time) {
      if (remain_minute_num < 5) {
        desk_back_class_name += " " + Style.is_ending;
      }
    } else {
    }
  }

  let top_sub_text: any = "";
  if (desku_info != null) {
    top_sub_text = (
      <span title={time_period}>
        {/* <span>좌석 {desk_num_str}.</span> */}
        <span className="ml-2">
          <span style={{ color: desk_is_finish ? "#000" : "#2eb62c", fontSize: "20px" }}>
            {is_target_time ? remain_minute_num : elapse_minute_num}
          </span>
          <span className="ml-1">분{is_target_time ? " 남음" : " "}</span>
        </span>
      </span>
    );
  }

  return (
    <div className={Style.card_box}>
      <div className={Style.card_box_back}></div>
      <div className={Style.card_box_back_white}>
        <div style={{ width: "100%", height: "100%", ...back_white_style }}></div>
      </div>
      <div className={Style.card_box_check_box_wrap}>
        <div style={{ position: "relative" }}>
          <input type="checkbox" className={Style.card_box_check_box} checked={is_checked} value=""
            onChange={on_change_check_box} />
          <span className="ml-1" style={{ color: attend_data.back_color, position: "absolute", right: "10px" }}
            title={attend_data.text + " " + attend_data.time.substring(0, 5)}>
            {attend_data.show_text}
          </span>
        </div>
      </div>
      <div className={Style.card_box_con} style={box_con_style}>
        <div style={box_con_div_style}>
          <TopInfoArea
            info={myProps.info}
            Style={myProps.Style}
            td_sort_data_arr={td_sort_data_arr}
            sub_title_text={top_sub_text}
            subject_name={subject_name}
            openTodoDaySort={myProps.openTodoDaySort}
            show_detail_user_by_seq={myProps.show_detail_user_by_seq}
          ></TopInfoArea>
          <MidTodoArea
            info={myProps.info}
            Style={myProps.Style}
            td_sort_data_arr={td_sort_data_arr}
            subject_name={subject_name}
            base_date_str={base_date_str}
            pre_date_str={pre_date_str}
            daily_info={daily_info}
            openTodoDaySort={myProps.openTodoDaySort}
            openTodoWriteOnePopup={myProps.openTodoWriteOnePopup}
          ></MidTodoArea>
          {/* <CardBoxAttendArea 
            user_info={info}
            attend_in_info={attend_in_info}
            attend_out_info={attend_out_info}
            attend_color={attend_color}
            xColumnArr={myProps.xColumnArr}
            deleteAttend={myProps.deleteAttend}
            openAttendPopup={myProps.openAttendPopup}
            Style={myProps.Style}></CardBoxAttendArea> */}
        </div>
      </div>
      <TodoDailyCArea
        stu_info={info}
        row_check_val={row_check_val}
        subject_name={subject_name}
        todo_dailyc_info={todo_dailyc_info}
        set_todo_dailyc_info={(inData: any) => {
          let tmp_info = { ...info };
          if (!strFunc.is_empty(subject_name)) {
            if (info.todo_dailyc_arr) {
              for (let i = 0; i < info.todo_dailyc_arr.length; i++) {
                if (inData.a_stu_seq == info["a_seq"]) {
                  if (info.todo_dailyc_arr[i].a_subject == subject_name) {
                    tmp_info.todo_dailyc_arr[i] = inData;
                  }
                }
              }
            } else {
              tmp_info.todo_dailyc_arr = [inData];
            }
          }
          myProps.set_info(tmp_info);
        }}
        openTodoDailyCWritePopup={myProps.openTodoDailyCWritePopup}
        go_todo_dailyc_write={myProps.go_todo_dailyc_write}
      ></TodoDailyCArea>
      {is_complete &&
        <>
          <div style={{ position: "absolute", textAlign: "center", width: "100%", top: "90px" }}>
            <img src={plan_complete_stamp_ico} style={{ width: "110px", transform: "rotate(-20deg)" }} />
          </div>
          <TodoDailycStarArea
            todo_dailyc_info={todo_dailyc_info}
          ></TodoDailycStarArea>
        </>
      }

    </div>
  );
}
export default CardBox;